import { isExternalLink } from '@spotify/plugin-confidence-artifacts-react';

export const getResourceName = (uri: string): string =>
  uri.replace(/^\/\//, '');

export const isInternalResource = (uri: string): boolean =>
  uri.startsWith('//') ||
  getResourceName(uri).startsWith('collaborativeDocuments/');

export const isGoogleDocUrl = (uri: string): boolean =>
  /^https:\/\/docs\.google\.com\/document\/d\//i.test(uri);

const RULE_PARENT_FLAG_RE = /^(?:\/\/)?(flags\/[^/]+)\/rules\/[^/]+$/;

export const isDocumentUri = (uri: string): boolean =>
  getResourceName(uri).startsWith('collaborativeDocuments/');

export const getArtifactNavigationPath = (uri: string): string | undefined => {
  if (isExternalLink(uri) || isDocumentUri(uri)) {
    return undefined;
  }
  const resourceName = getResourceName(uri);
  const ruleMatch = uri.match(RULE_PARENT_FLAG_RE);
  if (ruleMatch) {
    return ruleMatch[1];
  }
  return resourceName;
};
